// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__8Va+7"};